listTypeProcessReturnHO=[{
	code:'C',name: 'Tạo phiếu nhập kho hoàn trả'
},{
	code:'V',name: 'Xem phiếu nhập kho hoàn trả'
},{
	code:'A',name: 'Điều chỉnh phiếu nhập kho hoàn trả'
},{
	code:'E',name: 'Hủy phiếu nhập kho hoàn trả'
}];